import { adminRoute } from '@/modules/administration/routes';
import { createRoute } from '@tanstack/react-router';

export const fleetTripHistoryRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'fleet-trip-history',
  wrapInSuspense: true,
});
